import {luminance} from 'utils/common/color';
import * as colors from 'config/styles/colors';
import type {ThemeBase} from 'config/themes/base';

class DarkTheme implements ThemeBase {
  app = {
    logo: colors.primary.brand,
    header: colors.neutral.white,
    menu: colors.neutral.darker,
    content: colors.neutral.white,
    separator: '#ccc',
    selection: colors.primary.brand,
  }

  button = {
    primary: {
      fill: colors.primary.brand,
      text: colors.neutral.white,
      border: colors.primary.brand,
      hover: luminance(colors.primary.brand, -0.2),
    },
    destructive: {
      fill: colors.secondary.darkRed,
      text: colors.neutral.white,
      border: colors.secondary.darkRed,
      hover: luminance(colors.secondary.darkRed, -0.2),
    },
    cancel: {
      fill: colors.neutral.darker,
      text: colors.neutral.mid,
      border: colors.neutral.dark,
      hover: luminance(colors.neutral.darker, -0.2),
    },
  }

  dialog = {
    fill: colors.neutral.darker,
    hover: colors.neutral.darkest,
    border: colors.neutral.dark,
    overlay: 'rgba(0,0,0,0.6)',
    title: colors.neutral.lighter,
    text: colors.neutral.white,
    input: {
      fill: luminance(colors.neutral.darker, -0.4),
      text: colors.neutral.white,
      placeholder: colors.neutral.mid,
    },
  }

  menu = {
    fill: colors.neutral.dark,
    text: colors.neutral.mid,
    border: luminance(colors.neutral.mid, -0.4),
    hover: colors.neutral.darker,
    legal: '#bbb',
    header: {
      fill: colors.neutral.darker,
      text: colors.neutral.mid,
      border: colors.neutral.dark,
      hover: colors.neutral.darker,
      multi: luminance(colors.primary.dark, 0),
      multiBorder: '#5d75af',
      multiText: colors.neutral.white,
    }
  }

  login = {
    fill: colors.neutral.darker,
    header: colors.neutral.light,
    signup: colors.neutral.dark,
    signupText: colors.neutral.light,
  }

  files = {
    fill: luminance(colors.neutral.dark, -0.4),
    icon: colors.neutral.dark,
    navigator: {
      fill: luminance(colors.neutral.dark, -0.4),
      text: colors.neutral.light,
      border: colors.neutral.dark,
    },
    breadcrumbs: {
      fill: luminance(colors.neutral.dark, -0.4),
      text: colors.neutral.light,
      border: colors.neutral.dark,
      share: colors.neutral.darker,
      shareBorder: colors.neutral.mid,
    },
    listItem: {
      fill: luminance(colors.neutral.dark, -0.4),
      title: colors.neutral.lighter,
      border: colors.neutral.dark,
      focused: colors.neutral.darker,
      dragged: colors.neutral.darker,
      dropped: luminance(colors.neutral.darker, -0.6),
      selected: colors.primary.dark,
      selectedIcon: '#5d75af',
      selectedText: colors.neutral.light,
      selectedCheck: colors.primary.light,
      selectedFocused: luminance(colors.primary.dark, 0.4),
    },
    thumbnailSelector: {
      myFiles: {
        background: 'rgba(255, 255, 255, 0.1)',
        icon: 'rgba(255, 255, 255, 0.6)',
        activeBackground: 'rgba(255, 255, 255, 0.2)',
        activeIcon: colors.neutral.white,
      },
      shared: {
        background: luminance(colors.primary.dark, -0.3),
        icon: colors.neutral.light,
        activeBackground: colors.primary.brand,
        activeIcon: colors.neutral.white,
      }
    }
  }

  transfers = {
    fill: luminance(colors.neutral.dark, -0.4),
    icon: colors.neutral.dark,
    header: colors.neutral.darker,
    headerText: colors.neutral.light,
    headerTitle: colors.neutral.lighter,
    headerBorder: colors.neutral.dark,
    progress: {
      bar: luminance(colors.neutral.darker, -0.4),
      hashed: colors.neutral.mid,
      uploaded: colors.primary.brand,
    },
  }
}

export default new DarkTheme();
